import { Component, Input, OnInit } from '@angular/core';
import * as FileSaver from 'file-saver';
import { AttachmentService } from '../../common/attachment/attachment.service';
import { AttachmentDto } from '../../common/attachment/attachment';

@Component({
  selector: 'app-view-file',
  templateUrl: './view-file.component.html',
  styleUrls: ['./view-file.component.css']
})
export class ViewFileComponent implements OnInit {
  @Input() labelKey: string;
  @Input() attachment: AttachmentDto | null;

  constructor(private attachmentService: AttachmentService) { }

  ngOnInit(): void {}

  download(id) {
    this.attachmentService.get(id).subscribe((result: any) => {
      if (result) {
        const byteCharacters = atob(result.fileContent);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const file = new Blob([byteArray], { type: result.contentType });
        FileSaver.saveAs(file, result.fileName);
      }
    });
  }
}
